<div class="main-tabs" id="mainTabs">
    <div class="games-menu__tabs">
        <button class="games-menu__tab"
                (click)="onShowDepositTab()"
                [class.is-active]="isDepositTabActive()">
            <span>Deposit</span>
        </button>
        <button class="games-menu__tab"
                (click)="onShowRedeemTab()"
                [class.is-active]="isRedeemTabActive()">
            <span>Redeem</span>
        </button>
    </div>
    <div class="games-menu__title">
        <div class="games-menu__game-pic-wrapper">
            <img class="games-menu__game-pic"
                 id="gameTitleLogo"
                 src=""
                 title="Open Menu"
                 alt="Open Menu">
        </div>
        <img class="games-menu__game-title"
             id="gameTitleImg"
             src=""
             [alt]="getProviderName()">
    </div>
</div>
